import React, { Dispatch, SetStateAction, useEffect, useRef, useState, useCallback, FormEvent, useMemo } from 'react';
import styles from "./inviteView.module.scss";
import Button from "../../../../components/button/Button";
import { CellValue, Workbook } from 'exceljs';
import Select from "../../../../components/select/Select";
import { UserRoleEnum, SelectOption } from "../../../../types";
import {cleanRichText, isRichText} from "../../../../utils/helpers";
import { TextInput, TextInputValue } from '@src/components/text-input/TextInput';
import RadioGroup from '@src/components/radio-group/RadioGroup';
import { useAdminUsersLazyQuery, useCreateInviteMutation, useGetAccountSchoolsLazyQuery } from '@src/api/graphql-codegen';
import SelectMulti from '@src/components/select-multi/SelectMulti';
import { isEmptyObject, validateEmail, validateIsEmpty } from '../../../../utils/validation';
import { useToast } from '@src/hooks';
import { logger } from '../../../../utils/logger';

const header = ["Role", "First Name", "Last Name", "Email", "Account", "School"];
const headerSchools = ["Schools"];

const list = [
  [],
]
let blob;

const emptyErrors = {
  firstName: '',
  lastName: '',
  email: '',
  account: '',
  school: '',
  adminUser: '',
  districtSchools: '',
};

export const options = [
  {label: "Teacher", value: UserRoleEnum.User},
  {label: "School Admin", value: UserRoleEnum.Admin},
  {label: "District Admin", value: UserRoleEnum.DistrictAdmin},
  {label: "OP Content Admin", value: UserRoleEnum.ContentAdmin},
  {label: "OP Super Admin", value: UserRoleEnum.SuperAdmin}
]

type ErrorFields = Partial<Record<keyof typeof emptyErrors, string>>;

let generateExcelWithHead = (list: any[], header: any[], accountOptions: any[], account: string, schoolOptions: any[], school: string) => {
  let workbook = new Workbook();

  let worksheet = workbook.addWorksheet('OP Bulk Upload');
  // let accounts = workbook.addWorksheet('Accounts');
  let schools = workbook.addWorksheet('Schools');
  schools.state = 'veryHidden';
  let accountList = workbook.addWorksheet('AccountList');
  accountList.state = 'veryHidden';
  accountList.addRow([account])

  worksheet.mergeCells('A1:H1');
  worksheet.mergeCells('A2:H2');

  let row1 = worksheet.getCell("A1");
  row1.value = "Open Parachute Bulk User Uploader";
  // row1.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: {argb: 'FFB073'},
  //     bgColor: {argb: 'FFB073'}
  // }
  row1.font = {
    size: 20
  }

  let row2 = worksheet.getCell("A2");
  row2.value = "Please use the dropdowns for Role and School. You will not be able to do not do bulk uploads for multiple Accounts on the same Bulk Upload.";

  let headerRow = worksheet.addRow(header);
  schools.addRow(headerSchools);

  headerRow.eachCell((cell, number) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFB073'},
      bgColor: {argb: 'FFB073'}
    }
    cell.border = {top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}}
  })

  for (let i = 1; i <= 7; i++) worksheet.getColumn(i).width = 28;

  schoolOptions.map(tem => [tem.label]).forEach(d => schools.addRow(d));

  // @ts-ignore
  worksheet.dataValidations.model['A4:A9999'] = {
    allowBlank: true,
    error: 'Please use the drop down to select a valid value',
    errorTitle: 'Invalid Selection',
    formulae: ['"Teacher,Admin"'],
    showErrorMessage: true,
    type: 'list',
  };
  // @ts-ignore
  worksheet.dataValidations.model['G4:G9999'] = {
    allowBlank: true,
    error: 'Please use the drop down to select a valid value',
    errorTitle: 'Invalid Selection',
    formulae: ['"Yes,No"'],
    showErrorMessage: true,
    type: 'list',
  };

  // @ts-ignore
  worksheet.dataValidations.model['F4:F9999'] = {
    allowBlank: false,
    error: 'Please use the drop down to select a valid value',
    errorTitle: 'Invalid Selection',
    formulae: ['Schools!$A$2:$A$9999'],
    showErrorMessage: true,
    type: 'list',
  };

  // @ts-ignore
  worksheet.dataValidations.model['E4:E9999'] = {
    allowBlank: false,
    error: 'Please use the drop down to select a valid value',
    errorTitle: 'Invalid Selection',
    formulae: ['AccountList!$A$1:$A$1'],
    showErrorMessage: true,
    type: 'list',
  };

  for (let v = 4; v <= 9999; v++) {
    let cellRole = worksheet.getCell(`A${v}`)
    let cellAccount = worksheet.getCell(`E${v}`)
    let cellSchool = worksheet.getCell(`F${v}`)
    cellAccount.value = account;
    cellRole.value = "Teacher";
    if (school.length > 0) cellSchool.value = school;
  }

  // Generate Excel File with given name
  workbook.xlsx.writeBuffer().then((data) => {
    let link = document.createElement('a');
    link.download = 'OP-Bulk-User-Uploader.xlsx';
    blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

    link.href = URL.createObjectURL(blob);
    link.click();
  })
}


type Props = {
  setJsonParse: Dispatch<SetStateAction<any[]>>;
  accountOptions: any;
  schools: any;
  closeSlide: any
};

export function InviteView(props: Props) {

  const fileUploader = useRef(null);
  const {setJsonParse, accountOptions, closeSlide} = props;
  const [linkCustomer, setLinkCustomer] = useState('');
  const [linkSchool, setLinkSchool] = useState('');
  const [linkSchoolOptions, setLinkSchoolOptions] = useState<SelectOption[]>([]);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [customer, setCustomer] = useState('');
  const [school, setSchool] = useState('');
  const [schoolOptions, setSchoolOptions] = useState<SelectOption[]>([]);
  const [error, setError] = useState<ErrorFields>(emptyErrors);
  const [beError, setBeError] = useState('');

  const [userType, setUserType] = useState('User');
  const [admin, setAdmin] = useState(false);
  const [districtAdmin, setDistAdmin] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [contentAdmin, setContentAdmin] = useState(false);

  const [districtSchools, setDistrictSchools] = useState<Array<string>>([]);
  const [adminUserOptions, setAdminUserOptions] = useState<SelectOption[]>([]);
  const [adminUser, setAdminUser] = useState('');

  const [bulkCustomer, setBulkCustomer] = useState('');
  const [bulkSchool, setBulkSchool] = useState('');
  const [bulkSchoolOptions, setBulkSchoolOptions] = useState<SelectOption[]>([]);

  const { successToast } = useToast();

  const [getSchools, {loading: schoolOptionsLoading}] = useGetAccountSchoolsLazyQuery({fetchPolicy: 'network-only'})

  const [getAdminUsers, {loading: adminUsersLoading}] = useAdminUsersLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted(res) {
      setAdminUserOptions((res?.adminUsers ?? []).map(s => {
        return {
          value: s?.id ?? "",
          label: s?.name ?? "",
        };
      }));
    }
  });

  const [createInvite, {loading}] = useCreateInviteMutation({
    onError(e) {
      setBeError(e.message);
    },
    update(cache, response) {
      // const u = response.data?.superAdminInviteUser;
      // if (u) {
      //   const usersResponse = cache.readQuery<UsersResponse>({query: usersQuery});
      //   cache.writeQuery({
      //     query: usersQuery,
      //     data: {
      //       users: [u, ...usersResponse?.users || []],
      //     }
      //   });
      // }
      successToast('User invited Successfully!');
      clearFields();
      closeSlide();
    }
  });

  useEffect(() => {
    setAdmin(userType === UserRoleEnum.Admin);
    setDistAdmin(userType === UserRoleEnum.DistrictAdmin);
    setContentAdmin(userType === UserRoleEnum.ContentAdmin);
    setSuperAdmin(userType === UserRoleEnum.SuperAdmin);
  }, [userType]);

  useEffect(() => {
    if (linkCustomer) {
      const fetchSchools = async () => {
        const res = await getSchools({ variables: { input: { id: linkCustomer } } })
        return res.data?.accountSchools
      }
      fetchSchools().then(res => {
        if (res) {
          setLinkSchoolOptions((res.schools ?? []).map(s => {
            return {
              value: s?.id ?? '',
              label: s?.name ?? '',
            };
          }));
        }
      }).catch(console.error);
    }
  }, [getSchools, linkCustomer]);

  useEffect(() => {
    if (customer) {
      const fetchSchools = async () => {
        const res = await getSchools({ variables: { input: { id: customer } } })
        return res.data?.accountSchools
      }
      fetchSchools().then(res => {
        if (res) {
          setSchoolOptions((res.schools ?? []).map(s => {
            return {
              value: s?.id ?? '',
              label: s?.name ?? '',
            };
          }));
        }
      }).catch(console.error);
    }
  }, [getSchools, customer]);

  useEffect(() => {
    if (bulkCustomer) {
      const fetchSchools = async () => {
        const res = await getSchools({ variables: { input: { id: bulkCustomer } } })
        return res.data?.accountSchools
      }
      fetchSchools().then(res => {
        if (res) {
          setBulkSchoolOptions((res.schools ?? []).map(s => {
            return {
              value: s?.id ?? '',
              label: s?.name ?? '',
            };
          }));
        }
      }).catch(console.error);
    }
  }, [getSchools, bulkCustomer]);

  useEffect(() => {
    if (school && userType === 'User') {
      getAdminUsers({ variables: { input: { id: school } } });
    }
  }, [getAdminUsers, school, userType]);

  const clearFields = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setDisabled(false);
    setCustomer('');

    setAdminUser('');
    setAdmin(false);
    setDistAdmin(false);
    setContentAdmin(false);
    setSuperAdmin(false);

    setSchoolOptions([]);
    setAdminUserOptions([]);
    setBeError('');
    setError(emptyErrors);
  };

  const handleChangeText = (setter: Dispatch<SetStateAction<string>>, key: keyof typeof emptyErrors) => (value: TextInputValue) => {
    setter(value as string);
    setError({
      ...error,
      [key]: '',
    });
  };

  const handleChangeOption = (setter: Dispatch<SetStateAction<string>>, key: keyof typeof emptyErrors) => (value) => {
    setter(value.value);
    setError({
      ...error,
      [key]: '',
    });

    if (key === 'account') {
      setSchool('');
      setSchoolOptions([]);
      setAdminUser('');
      setAdminUserOptions([]);
    }

    if (key === 'school') {
      setAdminUser('');
      setAdminUserOptions([]);
    }
  };

  const handleChangeMultiSelect = useCallback((options: string[]) => {
    setDistrictSchools(options);
  }, []);

  const validate = () => {
    const errors: ErrorFields = {};

    if (validateEmail(email)) {
      errors.email = validateEmail(email);
    }

    if (validateIsEmpty(firstName)) {
      errors.firstName = 'First name must not be empty.';
    }

    if (validateIsEmpty(lastName)) {
      errors.lastName = 'Last name must not be empty.';
    }

    if (validateIsEmpty(customer)) {
      errors.account = 'Account must not be empty.';
    }

    if (admin && validateIsEmpty(school)) {
      errors.school = 'School must not be empty for School Admin.';
    }

    if (!admin && !superAdmin && !districtAdmin) {
      if (validateIsEmpty(school)) {
        errors.school = 'Please select a school first.';
      }
    }

    return errors;
  }
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const errors = validate();
    if (isEmptyObject(errors)) {
      setError(emptyErrors);
      setBeError('');
      createInvite({
        variables: {
          input: {
            firstName,
            lastName,
            email,
            disabled,
            customer,
            school,
            admin,
            districtAdmin,
            superAdmin,
            adminId: adminUser,
            districtSchools: districtAdmin ? JSON.stringify(districtSchools) : undefined,
            contentAdmin
          }
        },
      });
    } else {
      setError(errors);
    }
  };

  const handleInputChange = (e: any) => {
    if (e.target.files.length > 0) {
      let f = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async (evt) => { // evt = on_file_select event
        /* Parse data */
        if (evt && evt.target) {
          // ------------------------
          const buffer = reader.result;
          const wbe = new Workbook();
          await wbe.xlsx.load(buffer as ArrayBuffer).then((workbook) => {

            let updatedDataOne: any[] = [];
            let updatedDataIndexOne = 0;

            try {
              workbook.eachSheet((sheet, id) => {
                if (sheet?.name === "OP Bulk Upload") sheet.eachRow((row, rowIndex) => {

                  let valv: CellValue[] | { [p: string | number]: CellValue } | any[] = row.values;

                  if (rowIndex > 3 && (valv[2] || valv[3] || valv[4])) {

                    if (isRichText(valv[2])) valv[2] = cleanRichText(valv[2]);

                    if (isRichText(valv[3])) valv[3] = cleanRichText(valv[3]);

                    if (isRichText(valv[4])) valv[4] = cleanRichText(valv[4]);

                    let rowData = {
                      account: valv[5],
                      adminEmail: "",
                      email: (typeof valv[4] === "string" && valv[4].trim().length > 0) ? valv[4].trim() : valv[4]?.text ? valv[4].text.trim() : "",
                      firstName: valv[2] || "",
                      lastName: valv[3] || "",
                      id: updatedDataIndexOne,
                      invite: "Yes",
                      role: valv[1] || "Teacher",
                      school: typeof valv[6] === 'string' ? valv[6].trim() : valv[6]
                    }
                    updatedDataIndexOne++;
                    updatedDataOne.push(rowData);
                  }
                })
                setJsonParse(updatedDataOne)
              })
            } catch (e) {
              logger.info(e)
            }

          })
        }

      };
      reader.readAsBinaryString(f);
    }
  }

  const longLink = useMemo(() => {
    if (linkSchool) {
      return `${window.location.protocol}//${window.location.host}/registration?id=${linkSchool}&entity=sch`
      // return `${window.location.origin}?reg=${linkSchool}`;
    }
    return '';
  }, [linkSchool]) ;

  const copyLongLink = useCallback(async () => {
    await navigator.clipboard.writeText(`${window.location.protocol}//${window.location.host}/registration?id=${linkSchool}&entity=sch`)
    successToast('Link copied successfully!');
  }, [successToast, linkSchool])

  const isLoading = loading;
  const enableInvite = useMemo(() => {
    if (email !== '' && firstName !== '' && lastName !== '' && school !== '' && customer !== '') {

      return true
    }
    return false
  }, [email, firstName, lastName, school, customer])

  const accountSelected = bulkCustomer.length > 0;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.gridItem}>
          <div className={styles.subTitle}>Registration Link</div>
          <Select label={'Account'} options={accountOptions}
            searchAutoFocus
            value={linkCustomer} onChange={e => setLinkCustomer(e.value)}/>
          <div style={{marginTop: 20, marginBottom: 20}}>
            <Select label={'School'}
              disabled={schoolOptionsLoading || linkSchoolOptions.length === 0}
              options={linkSchoolOptions}
              searchAutoFocus
              value={linkSchool} onChange={e => setLinkSchool(e.value)}/>
          </div>
          <Button disabled={longLink === ''} label='Copy Registration Link' size='small' className={styles.copyLinkButton} onClick={copyLongLink}/>
        </div>
        <div className={styles.gridItem}>
        <div className={styles.subTitle}>Invite One-by-One</div>
        <div className={styles.normalText} >{'Invite users one by one below:'}</div>
        <form onSubmit={handleSubmit}>
          <div className={styles.content}>
            <TextInput hasError={!!error.firstName} subTitle={error.firstName} placeholder={'First Name'}
                    label={'First name'} id={'firstName'} value={firstName}
                    onChange={handleChangeText(setFirstName, 'firstName')}/>
            <TextInput hasError={!!error.lastName} subTitle={error.lastName} placeholder={'Last Name'}
                    label={'Last name'} id={'lastName'} value={lastName}
                    onChange={handleChangeText(setLastName, 'lastName')}/>
            <TextInput allowSpecialCharacters hasError={!!error.email} subTitle={error.email} placeholder={'Email'}
                    label={'Email'}
                    id={'email'} value={email}
                    onChange={handleChangeText(setEmail, 'email')}/>
            <Select error={!!error.account} subTitle={error.account} label={'Account'} options={accountOptions}
                    value={customer}
                    onChange={handleChangeOption(setCustomer, 'account')} searchAutoFocus/>
            <Select error={!!error.school} subTitle={error.school}
                    disabled={schoolOptionsLoading || schoolOptions.length === 0} label={'School'}
                    options={schoolOptions}
                    value={school}
                    onChange={handleChangeOption(setSchool, 'school')} searchAutoFocus/>
            {districtAdmin ? (
            <SelectMulti label={'District schools'} options={schoolOptions} value={districtSchools}
                    onChange={handleChangeMultiSelect} showSearch searchAutoFocus
                    error={districtAdmin && !!error.districtSchools}
                    subTitle={error.districtSchools || undefined}
                    disabled={schoolOptionsLoading || schoolOptions.length === 0}
              />
            ) : null}

            <div className={styles.inline}>
              <label className={styles.label}>User Type</label>
              <div>
                <div/>
                <RadioGroup
                  value={userType}
                  options={options}
                  onChange={(val) => setUserType(val)}
                  name={''}
                  hasError={false}
                  subTitle={""}
                />
              </div>
            </div>
            {admin || districtAdmin || superAdmin || contentAdmin ? '' : (
            <Select error={!!error.adminUser} subTitle={error.adminUser}
                    label={'Admin User'} options={adminUserOptions} value={adminUser}
                    disabled={adminUsersLoading || !adminUserOptions.length}
                    loading={adminUsersLoading}
                    onChange={handleChangeOption(setAdminUser, 'adminUser')} searchAutoFocus/>
            )}
            {Boolean(beError) && <div className={styles.error}>{beError}</div>}
            <div className={styles.action}>
              <Button disabled={isLoading || !enableInvite} type={'submit'} label={'Invite User'}/>
            </div>
          </div>
        </form>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.subTitle}>Bulk Invite</div>
          <div className={styles.normalText}>Importing an Excel file (XLSX) enables you to upload a large number of new users to your account in one go. To get started:</div>
          <h3 className={styles.bulkInviteSubTitle}>Step 1: Generate and Download Your Template</h3>
          <Select label={'Please select an Account to bulk upload user for:'} options={accountOptions}
                  searchAutoFocus
                  value={bulkCustomer} onChange={e => setBulkCustomer(e.value)}/>
          <div style={{marginTop: 20}}>
            <Select label={'Please select a default School to bulk upload user for (Optional):'}
                    disabled={bulkSchoolOptions.length === 0}
                    options={bulkSchoolOptions}
                    searchAutoFocus
                    value={bulkSchool} onChange={e => setBulkSchool(e.value)}/>
          </div>
          {(
            <div style={{marginBottom: 20, marginTop: 10}}>
              <div className={styles.downloadText}>Download our Excel Bulk Upload template file:</div>
              <a
                title={accountSelected ? "Download" : "Please select an account first"}
                className={styles.downloadLink}
                href='/'
                onClick={(e) => {
                  e.preventDefault();
                  if (!accountSelected || schoolOptionsLoading) {
                    window.alert("Please select an account to do a bulk upload for first!");
                  } else if (bulkSchoolOptions.length === 0) {
                    window.alert("There are no schools for this account!");
                  } else {
                    let a = accountOptions.filter((obj: any) => obj.value === bulkCustomer);
                    let s = bulkSchoolOptions.filter((obj: any) => obj.value === bulkSchool);
                    if (a.length > 0) generateExcelWithHead(list, header, accountOptions, a.length > 0 ? a[0].label : "", bulkSchoolOptions, s.length > 0 ? s[0].label : "");
                  }
                }}
                download
              > Click to download</a>
            </div>
          )}
          <h3 className={styles.bulkInviteSubTitle}>Step 2: Upload Completed Excel Document</h3>
          <div className={styles.parentRow}>
            <div className={styles.uploader}>
              <input ref={fileUploader} onChange={(e) => handleInputChange(e)} type="file"
                     className={styles.fileInput}
                     accept=".csv, .xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
              <div className={styles.uploadDiv}>
                <Button label={'Upload Completed Template'}
                  color={'orange'}
                  size='small'
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // @ts-ignore
                    fileUploader?.current?.click();
                  }}
                  outline={true}
                  className={styles.inputButton}
                />
                <div className={styles.smallText}>or drag & drop completed template here</div>
              </div>
            </div>
          </div>
          <div className={styles.action}>
            <Button disabled={false} onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  // @ts-ignore
                  fileUploader?.current?.click();
                }} label={'UPLOAD USERS'}/>
          </div>
        </div>
      </div>
    </>
  );
}